import cfetch from 'cross-fetch'
import {
    EYM_TKN,
    REST_API
} from './constants'
import {changeAuth} from './auth'

export default function testToken( endpoint, token ){
    return dispatch => cfetch(`${REST_API}/${endpoint}?access_token=${token}`)
        .then( response => {
            let json = response.json().then( json => {
                if( !Array.isArray(json) ){
                    let lstg = window.localStorage
                    lstg.removeItem(EYM_TKN)
    
                    dispatch(changeAuth({
                        access_token: null,
                        authenticated: false,
                        error: 'Invalid Access Token'
                    }))
                }

            }) 


            return {
                response: response,
                json: json
            }
        })
} 


// WEBPACK FOOTER //
// ./src/actions/token.js